import React from "react";

export const FrequentlyAskQuestions = () => {
  return (
    <div className="frequently-ask-questions-section">
      <div className="frequently-ask-questions-banner-heading">
        Frequently Asked Questions
      </div>

      <div className="frequently-ask-questions-content">
        <div className="frequently-ask-questions">
          <div className="questions-content">
            Q1. Who can enroll in The Heart Empathetic Listener Course?
          </div>
          <div className="answer-content">
            A: Anyone with a passion for supporting others and building
            empathetic listening skills can enroll, regardless of their
            background.
          </div>
        </div>

        <div className="frequently-ask-questions">
          <div className="questions-content">
            Q2. How long does it take to complete the course?
          </div>
          <div className="answer-content">
            A: The course can be completed in just 4 hours, giving you essential
            skills quickly and efficiently.
          </div>
        </div>

        <div className="frequently-ask-questions">
          <div className="questions-content">
            Q3. What will I learn in this course?
          </div>
          <div className="answer-content">
            A: You’ll learn active listening techniques, empathy-driven
            communication, mental health basics, and how to provide effective
            support while maintaining personal boundaries.
          </div>
        </div>

        <div className="frequently-ask-questions">
          <div className="questions-content">
            Q4. Do I need any prior experience to join the course?
          </div>
          <div className="answer-content">
            A: No prior experience is necessary; we provide all the training and
            resources you need to become a skilled empathetic listener. safe
            place that helps people talk about their past trauma for social
            anxiety. Empathic approaches are applied by therapists to assist
            people to cope with and overcome these experiences, in the context
            of enabling healing and development.
          </div>
        </div>

        <div className="frequently-ask-questions">
          <div className="questions-content">
            Q5. Is there any certification provided after completing the course?
          </div>
          <div className="answer-content">
            A: Yes, upon successful completion, you will receive a certification
            as The Heart Empathetic Listener, which can open earning
            opportunities.
          </div>
        </div>

        <div className="frequently-ask-questions">
          <div className="questions-content">
            Q6. How can I earn after completing the course?
          </div>
          <div className="answer-content">
            A: Certified listeners can join The Heart platform and earn money by
            providing support to users who seek a listening ear. create a
            positive social identity and feel confident to interact with others.
          </div>
        </div>

        <div className="frequently-ask-questions">
          <div className="questions-content">
            Q7. Is the course online or offline?
          </div>
          <div className="answer-content">
            Both! You can choose to attend online from anywhere or join us in
            person at select locations in India or Dubai.
          </div>
        </div>

        <div className="frequently-ask-questions">
          <div className="questions-content">
            Q8. What kind of support can I expect as a listener?
          </div>
          <div className="answer-content">
            A: You’ll receive ongoing guidance, training updates, and quality
            control feedback to ensure you provide the best support possible.
          </div>
        </div>

        <div className="frequently-ask-questions">
          <div className="questions-content">
            Q9. How is the confidentiality of users ensured?
          </div>
          <div className="answer-content">
            A: The Heart emphasizes strict confidentiality and provides tools
            and training on maintaining privacy during interactions.
          </div>
        </div>

        <div className="frequently-ask-questions">
          <div className="questions-content">
            Q10. Can I choose my hours as The Heart empathetic listener?
          </div>
          <div className="answer-content">
            A: Yes, listeners have the flexibility to set their own hours and
            work according to their schedule, making it a convenient way to earn
            and help others.
          </div>
        </div>
      </div>
    </div>
  );
};
